module.exports = "<h2><mat-icon style=\"vertical-align: middle\">error</mat-icon>&nbsp; {{loc.get('DialogCaptchaErrorTitle')}} </h2>\n<p [innerHTML]=\"loc.get('DialogCaptchaErrorBody')\"></p>\n<div style=\"margin-top: 10px; text-align: right\">\n  <button mat-raised-button (click)=\"closeDialog()\">{{loc.get('Chiudi')}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog.html
// module id = ./src/app/dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog.html
// module chunks = main